import React from 'react';
import { Trans } from '@lingui/macro';

import { Section, Container, Typography, Grid } from 'components';

import PhoneGameplay from 'assets/images/black-friday/phone_gameplay.png';
import PhoneSongs from 'assets/images/black-friday/phone_songs.png';
import PhoneArtist from 'assets/images/black-friday/phone_artist.png';
import PhoneInstruments from 'assets/images/black-friday/phone_instruments.png';

import { Benefits } from './benefits';
import { Magazines } from './ratings';
import { Quotes } from './quotes';
import { ImageContainer, ColumnStyled } from './styled';

export const ExistingUsersSections = () => {
    return (
        <React.Fragment>
            <Section background="labels">
                <Container>
                    <Grid alignCenter>
                        <ColumnStyled cols={6} tablet={12}>
                            <ImageContainer rightMargin>
                                <img src={PhoneSongs} alt="" />
                            </ImageContainer>
                        </ColumnStyled>
                        <ColumnStyled $order={1} cols={6} tablet={12}>
                            <Typography
                                variant="h2"
                                spaceBottom="medium"
                                color="semidarkGrey"
                            >
                                <Trans>Explore 10,000+ songs and lessons</Trans>
                            </Typography>

                            <Typography variant="bodyl" color="baseGray">
                                <Trans>
                                    Learn the songs you love with unlimited
                                    access to our full library of 10,000+
                                    popular songs, lessons and exercises.
                                    Updated weekly, there’s always something new
                                    to discover!
                                </Trans>
                            </Typography>
                        </ColumnStyled>
                    </Grid>
                </Container>
            </Section>

            <Section background="white">
                <Container>
                    <Grid alignCenter>
                        <ColumnStyled cols={6} tablet={12}>
                            <Typography
                                variant="h2"
                                spaceBottom="medium"
                                color="semidarkGrey"
                            >
                                <Trans>
                                    Get tips and tricks from artists you love
                                </Trans>
                            </Typography>

                            <Typography variant="bodyl" color="baseGray">
                                <Trans>
                                    Learn and play with your favorite artists in
                                    all-new Spotlight courses. Get tips,
                                    stories, exclusive performances and more
                                    from world-famous musicians like Jason Mraz
                                    and Juanes. Next up? Metallica!
                                </Trans>
                            </Typography>
                        </ColumnStyled>
                        <ColumnStyled cols={6} tablet={12} $order={-1}>
                            <ImageContainer leftMargin>
                                <img src={PhoneArtist} alt="" />
                            </ImageContainer>
                        </ColumnStyled>
                    </Grid>
                </Container>
            </Section>

            <Section background="labels">
                <Container>
                    <Grid alignCenter>
                        <ColumnStyled cols={6} tablet={12}>
                            <ImageContainer rightMargin>
                                <img src={PhoneInstruments} alt="" />
                            </ImageContainer>
                        </ColumnStyled>
                        <ColumnStyled cols={6} tablet={12}>
                            <Typography
                                variant="h2"
                                spaceBottom="medium"
                                color="semidarkGrey"
                            >
                                <Trans>Learn all 5 instruments</Trans>
                            </Typography>

                            <Typography variant="bodyl" color="baseGray">
                                <Trans>
                                    Guitar, ukulele, bass, piano, vocals—which
                                    will you play next? Take your learning to
                                    new levels with learning paths, lessons and
                                    songs for every instrument.
                                </Trans>
                            </Typography>
                        </ColumnStyled>
                    </Grid>
                </Container>
            </Section>

            <Magazines />
        </React.Fragment>
    );
};

export const NewUsersSections = () => {
    return (
        <React.Fragment>
            <Section background="labels">
                <Container>
                    <Grid alignCenter>
                        <ColumnStyled cols={6} tablet={12}>
                            <ImageContainer rightMargin>
                                <img src={PhoneGameplay} alt="" />
                            </ImageContainer>
                        </ColumnStyled>
                        <ColumnStyled cols={6} tablet={12}>
                            <Typography
                                variant="h2"
                                spaceBottom="medium"
                                color="semidarkGrey"
                            >
                                <Trans>
                                    The fun and easy way to learn an instrument
                                </Trans>
                            </Typography>

                            <Typography variant="bodyl" color="baseGray">
                                <Trans>
                                    Don’t worry, you can learn to play an
                                    instrument with Yousician regardless of your
                                    skill level. Follow learning paths created
                                    by music experts, learn techniques with
                                    step-by-step lessons and get real-time
                                    feedback while playing your favorite songs.
                                </Trans>
                            </Typography>
                        </ColumnStyled>
                    </Grid>
                </Container>
            </Section>

            <Benefits version="new_users" />

            <Section background="labels">
                <Container>
                    <Grid alignCenter>
                        <ColumnStyled cols={6} tablet={12}>
                            <Typography
                                variant="h2"
                                spaceBottom="medium"
                                color="semidarkGrey"
                            >
                                <Trans>Explore 10,000+ songs and lessons</Trans>
                            </Typography>

                            <Typography variant="bodyl" color="baseGray">
                                <Trans>
                                    Learn to play your favorite songs by artists
                                    you love with unlimited access to our
                                    library of 10,000+ popular songs, lessons
                                    and exercises. It’s updated weekly, so
                                    there’s always something new to discover!
                                </Trans>
                            </Typography>
                        </ColumnStyled>
                        <ColumnStyled cols={6} tablet={12} $order={-1}>
                            <ImageContainer leftMargin>
                                <img src={PhoneSongs} alt="" />
                            </ImageContainer>
                        </ColumnStyled>
                    </Grid>
                </Container>
            </Section>

            <Quotes />

            <Section background="labels">
                <Container>
                    <Grid alignCenter>
                        <ColumnStyled cols={6} tablet={12}>
                            <ImageContainer rightMargin>
                                <img src={PhoneArtist} alt="" />
                            </ImageContainer>
                        </ColumnStyled>
                        <ColumnStyled cols={6} tablet={12}>
                            <Typography
                                variant="h2"
                                spaceBottom="medium"
                                color="semidarkGrey"
                            >
                                <Trans>
                                    Get tips and tricks from artists you love
                                </Trans>
                            </Typography>

                            <Typography variant="bodyl" color="baseGray">
                                <Trans>
                                    Learn and play with your favorite artists in
                                    all-new Spotlight courses. Get tips,
                                    stories, exclusive performances and more
                                    from world-famous musicians like Jason Mraz
                                    and Juanes. Next up? Metallica!
                                </Trans>
                            </Typography>
                        </ColumnStyled>
                    </Grid>
                </Container>
            </Section>
        </React.Fragment>
    );
};

export const FamilyOnlyUsersSections = () => {
    return (
        <React.Fragment>
            <Benefits version="family" />

            <Section background="labels">
                <Container>
                    <Grid alignCenter>
                        <ColumnStyled cols={6} tablet={12}>
                            <ImageContainer rightMargin>
                                <img src={PhoneGameplay} alt="" />
                            </ImageContainer>
                        </ColumnStyled>
                        <ColumnStyled cols={6} tablet={12}>
                            <Typography
                                variant="h2"
                                spaceBottom="medium"
                                color="semidarkGrey"
                            >
                                <Trans>Discover your journey, together</Trans>
                            </Typography>

                            <Typography variant="bodyl" color="baseGray">
                                <Trans>
                                    With four personal, private accounts under
                                    one single plan, you can practice solo on
                                    your own devices while sharing musical
                                    milestones and having fun as a family.
                                </Trans>
                            </Typography>
                        </ColumnStyled>
                    </Grid>
                </Container>
            </Section>

            <Section background="white">
                <Container>
                    <Grid alignCenter>
                        <ColumnStyled cols={6} tablet={12}>
                            <Typography
                                variant="h2"
                                spaceBottom="medium"
                                color="semidarkGrey"
                            >
                                <Trans>Explore 10,000+ songs and lessons</Trans>
                            </Typography>

                            <Trans>
                                With 10,000+ popular songs, lessons and
                                exercises, our library has something for every
                                family member. Learn to play your favorite
                                songs, explore new genres, and create song
                                collections. Updated weekly, so there’s always
                                something new to discover!
                            </Trans>
                        </ColumnStyled>
                        <ColumnStyled cols={6} tablet={12} $order={-1}>
                            <ImageContainer leftMargin>
                                <img src={PhoneSongs} alt="" />
                            </ImageContainer>
                        </ColumnStyled>
                    </Grid>
                </Container>
            </Section>

            <Section background="labels">
                <Container>
                    <Grid alignCenter>
                        <ColumnStyled cols={6} tablet={12}>
                            <ImageContainer rightMargin>
                                <img src={PhoneArtist} alt="" />
                            </ImageContainer>
                        </ColumnStyled>
                        <ColumnStyled cols={6} tablet={12}>
                            <Typography
                                variant="h2"
                                spaceBottom="medium"
                                color="semidarkGrey"
                            >
                                <Trans>
                                    Learn and play with the artists you love
                                </Trans>
                            </Typography>

                            <Typography variant="bodyl" color="baseGray">
                                <Trans>
                                    Learn and play with your favorite artists in
                                    all-new Spotlight courses. Get tips,
                                    stories, exclusive performances and more
                                    from world-famous musicians like Jason Mraz
                                    and Juanes. Next up? Metallica!
                                </Trans>
                            </Typography>
                        </ColumnStyled>
                    </Grid>
                </Container>
            </Section>

            <Magazines />
        </React.Fragment>
    );
};

export const NonLicensedSections = () => {
    return (
        <React.Fragment>
            <Benefits version="new_users" />

            <Section background="labels">
                <Container>
                    <Grid alignCenter>
                        <ColumnStyled cols={6} tablet={12}>
                            <ImageContainer rightMargin>
                                <img src={PhoneGameplay} alt="" />
                            </ImageContainer>
                        </ColumnStyled>
                        <ColumnStyled cols={6} tablet={12}>
                            <Typography
                                variant="h2"
                                spaceBottom="medium"
                                color="semidarkGrey"
                            >
                                <Trans>
                                    The fun and easy way to learn an instrument
                                </Trans>
                            </Typography>

                            <Typography variant="bodyl" color="baseGray">
                                <Trans>
                                    Don’t worry, you can learn to play an
                                    instrument with Yousician regardless of your
                                    skill level. Follow learning paths created
                                    by music experts, learn techniques with
                                    step-by-step lessons and get real-time
                                    feedback while playing your favorite songs.
                                </Trans>
                            </Typography>
                        </ColumnStyled>
                    </Grid>
                </Container>
            </Section>
        </React.Fragment>
    );
};
